import { createContext } from 'react';
// import { useStateManager } from '../hooks/useStateManager';

const defaultState: any = [];

const ProjectContext = createContext(defaultState);

export default ProjectContext;
